export default __webpack_public_path__ + "static/media/rhea1.6f701f1a.png";